<template>
  <div>
    <b-modal id="BookingVisitedCancel" size="lg" ref="BookingVisitedCancel" :title="noShowFlag? '노쇼내역' :'방문내역'">
      <b-row class="text-center">
        <b-col cols="2"></b-col>
        <b-col cols="8">
          <b-table-simple
            head-variant="light"
            ref="general-table"
            class="vuetable"
            id="table-transition-example"
            responsive=""
            align="center"
          >
            <b-thead head-variant="light">
              <b-tr>
                <template v-for="(field , idx) in fields">
                  <b-th style="text-align: center">{{field.label}}</b-th>
                </template>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-td>{{$moment( data.visitDate ).format('YYYY-MM-DD HH:mm')}}</b-td>
                <b-td>{{data.storeName}}</b-td>
                <b-td>{{data.managerId}}</b-td>
              </b-tr>
            </b-tbody>

          </b-table-simple>
        </b-col>
        <b-col cols="2"></b-col>
      </b-row>

      <template slot="modal-footer">
        <b-button v-if="!noShowFlag" variant="primary" @click="showMemo">방문취소</b-button>
        <b-button v-if="noShowFlag" variant="primary" @click="showMemo">노쇼취소</b-button>
        <b-button variant="outline-primary" @click="ModalHide">닫기</b-button>
      </template>
    </b-modal>
    <modal-memo ref="modal_memo" :title="noShowFlag? '노쇼취소사유' : '방문취소신청사유'" data="" @confirm="cancel"></modal-memo>
  </div>
</template>
<script>
  import {currencyFilter, alignTableCenter} from "../../../utils";
  import ModalMemo from "../../order/components/ModalMemo";

  export default {
    components: {
      'modal-memo': ModalMemo
    },
    name: "CouponUseDetail",
    props: ['data','noShowFlag'],
    filters: {...currencyFilter},
    data() {
      return {
        allCheck: false,
        fields: [
          {key: 'visitDate', label: '사용일자', ...alignTableCenter},
          {key: 'storeName', label: '사용매장', ...alignTableCenter},
          {key: 'managerId', label: '처리자', ...alignTableCenter},
        ]
      }
    },
    mounted() {
    },
    methods: {
      open() {
        this.$refs['BookingVisitedCancel'].show()
      },
      showMemo() {
        this.$refs['modal_memo'].open()
      },
      cancel( memo ) {

        if(this.noShowFlag){
          if( confirm('노쇼를 취소하시겠습니까? ')  ) {
            this.$emit('noshow', memo)
            this.ModalHide();
          }
        }else{
          if( confirm('방문완료를 취소하시겠습니까? ')  ) {
            this.$emit('process', memo)
            this.ModalHide();
          }
        }

      },
      ModalHide() {
        this.$refs['BookingVisitedCancel'].hide()
      }
    }
  }
</script>
